import { maxForesight } from '../../utils/arena/oracle';
import ForesightGauge from '../play/ForesightGauge';

// The Oracle's banked Foresight under the constellation: the same vial the
// reading shows, in the slot the Alchemist's plate uses, so the foundation
// star above it stays clear.
export default function OracleForesight({ skillState, oracle }) {
  const max = maxForesight(skillState);
  return (
    <div className="vh-potency-slot relative" style={{ height: '3cqw' }} data-testid="oracle-foresight">
      <div className="absolute left-1/2 -translate-x-1/2" style={{ bottom: '-1.75cqw' }}>
        <ForesightGauge value={Math.min(oracle?.foresight || 0, max)} max={max} width={38} size={1.35} />
      </div>
    </div>
  );
}
